import { useCallback, useMemo } from 'react'

import { useRequestConfirmationBottomSheetContextBR } from 'contexts/bottomsheet-context/RequestConfirmationBottomSheetContextBR'
import { useAppContext } from 'contexts/app-context/hooks/useAppContext'
import { logBridgeError, sendSelectContent } from 'common'
import { useRequestConfirmationBottomSheetContextUS } from 'contexts/bottomsheet-context/RequestConfirmationBottomSheetContextUS'
import { Routes } from 'common/constants'

import { TDisableAllNotificationsBottomsheetProps } from '../types/DisableAllNotificationsBottomsheet.types'

export function useDisableAllNotifications({ producId }: TDisableAllNotificationsBottomsheetProps) {
  const { userSelectedEntity } = useAppContext()

  const isUS = useMemo(() => userSelectedEntity === 'US_BRANCH', [userSelectedEntity])

  const {
    showDialog: showDialogBR,
    setShowDialog: setShowDialogBR,
    showSuccessStep: showSuccessStepBR,
    setShowSuccessStep: setShowSuccessStepBR,
    mutation: mutationBR,
    changingFinalidade,
  } = useRequestConfirmationBottomSheetContextBR()

  const {
    showDialog: showDialogUS,
    setShowDialog: setShowDialogUS,
    showSuccessStep: showSuccessStepUS,
    setShowSuccessStep: setShowSuccessStepUS,
    mutation: mutationUS,
    changingPurpose,
  } = useRequestConfirmationBottomSheetContextUS()

  const onConfirm = useCallback(async () => {
    const screen = producId ? producId.toLowerCase() : '-'

    try {
      await sendSelectContent({
        flow: 'disable_notifications_bottomsheet',
        step: screen,
        screen_name: Routes.NOTIFICATIONS_MANAGEMENT,
        element_name: 'confirm_disable_all_notifications',
        element_type: 'button',
        parent_name: 'disable_notifications_bottomsheet',
        scenario: JSON.stringify({ screen }),
      })
    } catch (error: unknown) {
      logBridgeError('send disable all notifications confirm tic', error)
    }

    if (isUS) {
      mutationUS.mutate(changingPurpose)
    } else {
      mutationBR.mutate(changingFinalidade)
    }
  }, [mutationUS, changingPurpose, producId, mutationBR, changingFinalidade, isUS])

  const onDismiss = useCallback(async () => {
    const screen = producId ? producId.toLowerCase() : '-'

    try {
      await sendSelectContent({
        flow: 'disable_notifications_bottomsheet',
        step: screen,
        screen_name: Routes.NOTIFICATIONS_MANAGEMENT,
        element_name: 'cancel_disable_all_notifications',
        element_type: 'button',
        parent_name: 'disable_notifications_bottomsheet',
        scenario: JSON.stringify({ screen }),
      })
    } catch (error: unknown) {
      logBridgeError('send disable all notifications dismiss tic', error)
    }

    if (isUS) {
      setShowSuccessStepUS(false)
      setShowDialogUS(false)
    } else {
      setShowSuccessStepBR(false)
      setShowDialogBR(false)
    }
  }, [setShowSuccessStepUS, setShowDialogUS, producId, setShowSuccessStepBR, setShowDialogBR, isUS])

  const onClose = useCallback(() => {
    if (isUS) {
      setShowSuccessStepUS(false)
      setShowDialogUS(false)
    } else {
      setShowSuccessStepBR(false)
      setShowDialogBR(false)
    }
  }, [isUS, setShowDialogUS, setShowDialogBR, setShowSuccessStepBR, setShowSuccessStepUS])

  return {
    showDialogBR,
    showDialogUS,
    showSuccessStepBR,
    showSuccessStepUS,
    mutationBR,
    mutationUS,
    onClose,
    onConfirm,
    onDismiss,
  }
}
